// extracted by mini-css-extract-plugin
export var flyoverContainer = "styles-module__flyoverContainer___HzVVo";
export var proTag = "styles-module__proTag___OCpM2";